<template>
<div id="App">
  <transition
    @enter="enter" @after-enter="afterEnter"
    @leave="leave" @after-leave="afterLeave"
    @before-enter="beforeEnter"
    :css="false" appear :mode="mode">
    <keep-alive :include="['MarkerAr', 'Selfie']">
      <router-view ref="page" v-if="loaded && facebookReady && webcamReady && !IschromeIOS"/>
    </keep-alive>
  </transition>

  <Cookies v-if="cookie" />

  <Nowebcam v-if="webcamReady === false && !IschromeIOS" />
  <chromeIOS v-if="IschromeIOS" />
  <NoLandscape v-if="$root.width > $root.height" />

  <Promo v-if="showPromo" />

  <Loader v-if="!loaded"/>
</div>
</template>

<script>
import Loader from '@/components/loader/Loader'
import Transition from '@/core/mixins/Transition'
import Cookies from '@/components/cookies/Cookies'
import Nowebcam from '@/components/nowebcam/Nowebcam'
import NoLandscape from '@/components/nolandscape/NoLandscape'
import chromeIOS from '@/components/ischromeios/IschromeIOS'
import Brfv4 from '@/pages/selfie/brfv4/Brfv4_webcam'
import Promo from '@/components/promo/Promo'

export default {
  name: 'App',
  mixins: [ Transition ],
  components: { Loader, Cookies, Nowebcam, chromeIOS, NoLandscape, Promo },
  data: () => ({
    facebookReady: false,
    webcamReady: null,
    IschromeIOS: false,
    isLandscape: true,
    showPromo: false
  }),
  computed: {
    cookie() { return this.$store.getters['user/cookie'] },
    loaded() { return this.$store.getters['loader/loaded'] },
    shared() { return this.$store.getters['user/shared'] },
  },
  watch: {
    shared() {
      if(this.shared == 1 || this.shared == 2)
        this.showPromo = true
    },
  },
  created() {
    // this.$store.commit('user/SET_SHARE', 3)

    const userAgent = window.navigator.userAgent.toLowerCase()
    const ios = /iphone|ipod|ipad/.test(userAgent)

    if(ios && navigator.userAgent.match('CriOS'))
      return this.IschromeIOS = true

    navigator.mediaDevices.getUserMedia({ video: { frameRate: 30, facingMode: 'environment' } })
    .then(stream => this.webcamReady = true)
    .catch(err => this.webcamReady = false)

    window.fbAsyncInit = () => {
      FB.init({
        appId      : '1929376800506246',
        cookie     : true,  // enable cookies to allow the server to access
        xfbml      : true,  // parse social plugins on this page
        version    : 'v3.2' // The Graph API version to use for the call
      })
      this.facebookReady = true
    }

    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

    this.$brfv4 = new Brfv4()
    this.$brfv4.loadWasm()
  }
}
</script>

<style lang="stylus">
@import '~reset-css/reset.css'
@import '~@/config/Settings'
@import '~@/commons/fonts/Fonts'
@import '~@/commons/stylus/Global'
@import '~@/commons/stylus/Page'
@import '~@/commons/stylus/Vlazy'

#App
  position absolute
  height 100%
  width 100%
  overflow hidden

</style>
